import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../Components/Core/Loader";
import { verifySubscriptionPayment } from "../../Services/SubscriptionService";

const SubscriptionCallback = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const verifyPayment = useCallback(async () => {
    const authority = searchParams.get("Authority");
    const status = searchParams.get("Status");

    try {
      setLoading(true);
      if (status === "NOK" || !authority) {
        navigate("/subscription?result=fail");
        return;
      }
      await verifySubscriptionPayment(authority);
      navigate("/subscription?result=success");
    } catch (error) {
      console.error("Subscription payment verification failed:", error);
      navigate("/subscription?result=fail");
    } finally {
      setLoading(false);
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    verifyPayment();
  }, [verifyPayment]);

  return loading ? <Loader /> : null;
};

export default SubscriptionCallback;
